import React, { useState, useCallback, useEffect } from "react";
import { Link, Icon, LegacyStack, RadioButton } from "@shopify/polaris";
import { AppsIcon, ClipboardIcon } from "@shopify/polaris-icons";
import Product from "../modals/Product";
import Collection from "../modals/Collection";
import Pages from "../modals/Pages";
import axios from "axios";
import Swal from "sweetalert2";
import GoogleBingUATList from "./GoogleBingUATList";

const GoogleBingUAT = () => {
  const [value, setValue] = useState("no");
  const [value2, setValue2] = useState("no");
  const [value3, setValue3] = useState("no");
  const [isOpenProduct, setIsOpenProduct] = useState(false);
  const [isOpenCollection, setIsOpenCollection] = useState(false);
  const [isOpenPages, setIsOpenPages] = useState(false);
  const shop = "googledevelop.myshopify.com";
  const [code, setCode] = useState("");
  const appUrl = process.env.REACT_APP_BACKEND_APP_HOST;
  const [data, setData] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    tag_code: "",
    shop_url: shop,
    products: "all",
    pages: "all",
    collections: "all",
    products_json: "",
    pages_json: "",
    collections_json: "",
  });

  const handleChangeProduct = useCallback((newValue) => {
    setValue(newValue);
    setFormData((prev) => ({
      ...prev,
      products: newValue,
    }));
    // Open the Product modal if 'specific' is selected
    setIsOpenProduct(newValue === "specific");
  }, []);

  const handleChangePages = useCallback((newValue) => {
    setValue2(newValue);
    setFormData((prev) => ({
      ...prev,
      pages: newValue,
    }));
    // Open the Pages modal if 'specific' is selected
    setIsOpenPages(newValue === "specific");
  }, []);

  const handleChangeCollections = useCallback((newValue) => {
    setValue3(newValue);
    setFormData((prev) => ({
      ...prev,
      collections: newValue,
    }));
    // Open the Collection modal if 'specific' is selected
    setIsOpenCollection(newValue === "specific");
  }, []);

  const handleStoreData = (selectedProductIds) => {
    setFormData((prev) => ({
      ...prev,
      products_json: JSON.stringify(selectedProductIds),
    }));
  };

  const handleCollectionStoreData = (selectedCollectionIds) => {
    setFormData((prev) => ({
      ...prev,
      collections_json: JSON.stringify(selectedCollectionIds),
    }));
  };

  const handlePagesStoreData = (selectedPageIds) => {
    setFormData((prev) => ({
      ...prev,
      pages_json: JSON.stringify(selectedPageIds),
    }));
  };

  const handleEdit = (item) => {
    console.log("pr", item.products_json);
    setCode(item.tag_code);
    setFormData({
      ...formData,
      tag_code: item.tag_code,
      products: item.products,
      pages: item.pages,
      collections: item.collections,
      products_json: item.products_json,
      pages_json: item.pages_json,
      collections_json: item.collections_json,
    });
    setValue(item.products);
    setValue2(item.pages);
    setValue3(item.collections);
    setEditingId(item.id);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Prepare the submission data
    const submissionData = {
      tag_code: code,
      shop_url: shop,
      products: value,
      pages: value2,
      collections: value3,
      products_json: formData.products_json,
      pages_json: formData.pages_json,
      collections_json: formData.collections_json,
    };

    try {
      let response;
      if (editingId) {
        // Send PUT request to update the existing record
        response = await fetch(`${appUrl}/bing/edit/${editingId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submissionData),
        });
      } else {
        // Send POST request to create a new record
        response = await fetch(`${appUrl}/bing/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set content type to JSON
          },
          body: JSON.stringify(submissionData), // Stringify the JSON data
        });
      }

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: editingId
            ? "Record updated successfully!"
            : "Record created successfully!",
          confirmButtonText: "Ok",
        });

        // Update the local data state
        if (editingId) {
          // Update existing record in state
          setData((prevData) =>
            prevData.map((item) =>
              item.id === editingId ? { ...item, ...submissionData } : item
            )
          );
        } else {
          // Add new record to state
          setData((prevData) => [
            ...prevData,
            { ...submissionData, id: result.id },
          ]); // Assuming result contains the new ID
        }

        // Reset form state
        setEditingId(null);
        setFormData({
          tag_code: "",
          products: "all",
          pages: "all",
          collections: "all",
          products_json: "",
          pages_json: "",
          collections_json: "",
        });
        setCode("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: result.message || "Something went wrong, please try again.",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An unexpected error occurred.",
        confirmButtonText: "Ok",
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${appUrl}/bing?shop_url=${shop}`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching list:", error);
      }
    };

    fetchData();
  }, [shop]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        console.log("Text copied to clipboard");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  };

  console.log("data", data);
  return (
    <div className="google-account-container">
      <div>
        <h1 className="head">GA4 Accounts</h1>
      </div>
      <div>
        <GoogleBingUATList data={data} setData={setData} onEdit={handleEdit} />
      </div>
      <div className="finish-setup-wrapper">
        <div className="finish-main">
          <form onSubmit={handleSubmit}>
            <h4>Tag CODE</h4>
            <textarea
              required
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setFormData((prev) => ({
                  ...prev,
                  tag_code: e.target.value,
                }));
              }}
            />
            <div className="multi-links">
              <Link monochrome url="#" onClick={handleCopy}>
                <Icon source={ClipboardIcon} tone="base" />
                Copy
              </Link>
            </div>
            <h4>Products</h4>
            <LegacyStack vertical>
              <RadioButton
                label="All Products"
                checked={value === "all"}
                id="all_products"
                name="products"
                onChange={() => handleChangeProduct("all")}
              />
              <RadioButton
                label="Specific Product"
                id="specific_product"
                name="products"
                checked={value === "specific"}
                onChange={() => handleChangeProduct("specific")}
              />
              <RadioButton
                label="No Product"
                id="no_product"
                name="products"
                checked={value === "no"}
                onChange={() => handleChangeProduct("no")}
              />
            </LegacyStack>
            <h4>Pages</h4>
            <LegacyStack vertical>
              <RadioButton
                label="All Pages"
                checked={value2 === "all"}
                id="all_pages"
                name="pages"
                onChange={() => handleChangePages("all")}
              />
              <RadioButton
                label="Specific Pages"
                id="specific_pages"
                name="pages"
                checked={value2 === "specific"}
                onChange={() => handleChangePages("specific")}
              />
              <RadioButton
                label="No Pages"
                id="no_pages"
                name="pages"
                checked={value2 === "no"}
                onChange={() => handleChangePages("no")}
              />
            </LegacyStack>
            <h4>Collections</h4>
            <LegacyStack vertical>
              <RadioButton
                label="All Collections"
                checked={value3 === "all"}
                id="all_collections"
                name="collections"
                onChange={() => handleChangeCollections("all")}
              />
              <RadioButton
                label="Specific Collections"
                id="specific_collections"
                name="collections"
                checked={value3 === "specific"}
                onChange={() => handleChangeCollections("specific")}
              />
              <RadioButton
                label="No Collections"
                id="no_collections"
                name="collections"
                checked={value3 === "no"}
                onChange={() => handleChangeCollections("no")}
              />
            </LegacyStack>
            <div className="btn-container back">
              <button type="submit">Save</button>
            </div>
          </form>
        </div>

        {isOpenProduct && (
          <Product
            set={setIsOpenProduct}
            shop={shop}
            onStoreData={handleStoreData}
            data={formData.products_json}
          />
        )}
        {isOpenCollection && (
          <Collection
            set={setIsOpenCollection}
            shop={shop}
            onStoreData={handleCollectionStoreData}
            data={formData.collections_json}
          />
        )}
        {isOpenPages && (
          <Pages
            set={setIsOpenPages}
            shop={shop}
            onStoreData={handlePagesStoreData}
            data={formData.pages_json}
          />
        )}
      </div>
    </div>
  );
};

export default GoogleBingUAT;
